import Component from './StyleDemo'

export default Component
